import { FIELDS_SET, FIELD_ADD } from 'src/app/redux/redux-types';
import { reduxFieldsTypes } from 'src/types';

export const fieldsDefaultState: reduxFieldsTypes.StateType = {
  fieldsList: [],
};

export const fieldsReducer = (
  state = fieldsDefaultState,
  action: reduxFieldsTypes.ActionType,
): reduxFieldsTypes.StateType => {
  switch (action.type) {
    case FIELDS_SET:
      return {
        ...state,
        fieldsList: action.payload,
      };
    case FIELD_ADD:
      const isAdded = state.fieldsList.some((f) => f.id === action.payload.id);

      if (isAdded) return state;

      return {
        ...state,
        fieldsList: [...state.fieldsList, action.payload],
      };

    default:
      return state;
  }
};
